import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BookingState } from '@modules/booking/store';
import { selectServicesPerBooking } from '@public-page/store/company';

const selectBookingState = createFeatureSelector<BookingState>('booking');

export const selectServiceState = createSelector(selectBookingState, (s) => s.services);

export const selectServices = createSelector(selectServiceState, (s) => s.entities);

export const selectCheckedServices = createSelector(selectServiceState, (s) => s.selectedServices);

export const selectCheckedServicesSum = createSelector(
  selectCheckedServices,
  selectServices,
  (selectedServices, services) => {
    const checkedServices = selectedServices.map((uuid) => services.find((i) => i.uuid === uuid)?.price);

    return checkedServices.reduce((a: number | undefined, b: number | undefined) => Number(a) + Number(b), 0);
  }
);

export const selectCheckedServicesLength = createSelector(selectCheckedServices, (services) => {
  return services ? services.length : 0;
});

export const selectIsCanChecked = createSelector(
  selectCheckedServices,
  selectServicesPerBooking,
  (services, servicesPerBooking) => {
    const servicesPerBookingLength = servicesPerBooking as number;

    return !(services.length < servicesPerBookingLength);
  }
);
